/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 10:06:15
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-25 16:00:06
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\Carousel\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useRef } from "react";
import { Carousel } from "antd";
import { useTranslation } from "react-i18next";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./index.scss";
function ArchivesCarousel() {
  const carouselRef = useRef();
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const archivesCarouselCenter = t("solution_archives.archives4", {
    returnObjects: true,
  });
  return (
    <div className="archives_carousel_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{archivesCarouselCenter.til}</div>
          <span>{archivesCarouselCenter.detail}</span>
        </div>
      </div>
      <div className="carousel_btn">
        <div
          className="carousel_left"
          onClick={() => carouselRef.current.prev()}
        >
          <img
            src={
              require("../../../../assets/images/solution/toLeft.png").default
            }
            alt=""
          />
        </div>
        <div
          className="carousel_right"
          onClick={() => carouselRef.current.next()}
        >
          <img
            src={
              require("../../../../assets/images/solution/toRight.png").default
            }
            alt=""
          />
        </div>
      </div>
      <Carousel
        ref={carouselRef}
        className="carousel_con"
        dots={{className:"carousel_con_dots"}}
        infinite={true}
        slidesToShow={5} // 一页显示5个
        slidesToScroll={1} // 每次滚动1个
        //   autoplay={true}
        //   pauseOnHover={true} // 鼠标悬停暂停
        //   swipeToSlide={true} // 支持拖动滑动
        //   draggable={true}
      >
        {archivesCarouselCenter.contentList.map((item, index) => {
          return (
            <div
              className={`carousel_li ${language === "zh" ? "carousel_li_zh" : "carousel_li_en"}`}
              key={index}
              // style={
              //   language === "zh" ? { height: "240px" } : { height: "320px" }
              // }
            >
              <div className="carousel_img">
                <img src={item.imgUrl} alt="" />
              </div>
              <div className="carousel_title">{item.tit}</div>
              <div className="carousel_detail">
                {item.detailList.map((item1, index1) => {
                  return <div key={index1}>{item1}</div>;
                })}
              </div>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}

export default ArchivesCarousel;
